import BarOrderViewPage from "./BarOrderViewPage";

export {BarOrderViewPage}
export default BarOrderViewPage
